export default "__VITE_ASSET__DWgDyoF3__"